<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th class="item-number text-right">Precio de compra</th>
                            <th class="item-number text-right">Cantidad</th>
                            <th class="item-number text-right">Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in importation.detail" :key="item.id">
                            <td>{{ item.item_name }}</td>
                            <td class="text-right">{{ item.price | currency('S/') }}</td>
                            <td class="text-right">{{ item.quantity }}</td>
                            <td class="text-right">{{ item.subtotal | currency('S/') }}</td>
                        </tr>                        
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="2" class="foot-purchase"></td>
                            <td class="font-weight-medium">Total</td>
                            <td class="text-right">{{ importation.total | currency('S/') }}</td>
                        </tr>
                    </tfoot>

                </v-simple-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

export default {
    name: 'ImportationDetail',
    props: ['importation'],
    data() {
        return {
            detail: []
        }
    }
}
</script>

<style scoped>
.item-number{
    width: 150px !important;
    min-width: 150px !important;
}

.foot-purchase{
    border-bottom: 0px !important;
}
</style>